import { DateTime } from "luxon";

import IndicatorBadge from "@/components_v2/Badge/IndicatorBadge";
import AvatarMetaCard from "@/components_v2/Card/AvatarMetaCard";
import BaseListItem from "@/components_v2/List/BaseListItem";
import UserAvatar from "@/domains/users/components/UserAvatar";
import type { BaseUserResponse } from "@/redux/users/types";
import AnchorNotification from "./AnchorNotification";
import type { NotificationItemProps } from "../../types";

const SYSTEM_AUTHOR_FALLBACK = {
  id: 0,
  firstName: "PRME",
  lastName: "Commons",
  fullName: "PRME Commons",
  email: null,
  profilePicture: null,
} as unknown as BaseUserResponse;

const NotificationItem = ({
  notification,
  className,
}: NotificationItemProps) => {
  const card = (
    <AvatarMetaCard
      avatar={
        <UserAvatar user={notification.createdBy ?? SYSTEM_AUTHOR_FALLBACK} />
      }
      title={<AnchorNotification text={notification.title} />}
      description={DateTime.fromISO(notification.createdAt).toRelative()}
    />
  );

  return (
    <BaseListItem
      key={notification.id}
      className={`${className ?? ""} ${!notification.isRead ? "notifications-list-item--unread" : ""}`}
    >
      {!notification.isRead ? (
        <IndicatorBadge dot className="notifications-list-item-badge">
          {card}
        </IndicatorBadge>
      ) : (
        card
      )}
    </BaseListItem>
  );
};

export default NotificationItem;
